import { Enum } from '~/data/enums';
import {
  CustomFieldValues,
  FieldAttributes,
} from '~/legacy-components/CustomDataFields';
import { fetchFromOldApi } from '~/services/Http';

import { AnswerPreProcess } from '../../../../types';
export { prefetchCustomData } from './prefetchCustomData';

export const getCustomEmployeeFields = (
  id: string,
): Promise<CustomFieldValues> => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE/${id}`).then((r) =>
    r.json(),
  );
};

export const getCustomEmployeeFieldAttributes = (): Promise<
  FieldAttributes[]
> => {
  return fetchFromOldApi(`/json/customdata/entity/EMPLOYEE/attribute`).then(
    (r) => r.json(),
  );
};

export const getCustomEmployeeFieldLanguages = (
  strLang: string,
): Promise<Enum[]> => {
  return fetchFromOldApi(
    `/json/enum/CUSTOM_ENTITY_EMPLOYEE/${strLang}?includeInactive=false`,
  ).then((r) => r.json());
};

export const saveCustomFieldValues = (
  employeeId: string,
  customFieldValues: AnswerPreProcess,
) => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE/${employeeId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json; text/javascript; */*; q=0.01',
    },
    body: JSON.stringify(customFieldValues),
  }).then((r) => r.json());
};
